import { useAuth0 } from "@auth0/auth0-react"
import React from "react"

/**
 * Logout used by Zippin multi-tenant dashboards to logout the user from operator console
 * when they logout of Zippin multi-tenant dashboards.
 */
const Logout = () => {
  const auth0Provider = useAuth0()
  auth0Provider.logout()
  return <></>
}

export default Logout
